export default __webpack_public_path__ + "static/media/Pattern_Pillar_1.f4a70ddb.jpg";